
/** A language used by devs to identify keys. */
export const CIMODE = "cimode";

/** The default translation namespace. */
export const TRANSLATION_NAMESPACE = "translation";

/** An ISO language code, or the special cimode language. */
export type Lang = typeof CIMODE | string;

/** A record of resources to load into the service. */
export type ResourcesRecord = Record<Lang, ResourceJson>;

/** A resource. This consists of different namespaced translations. */
export type ResourceJson = {
  /** The translation (default) dictionary. */
  [TRANSLATION_NAMESPACE]?: DictionaryJson;

  /** A non-default namespaced dictionary. */
  [key: string]: DictionaryJson;
};

/** A JSON dictionary of translations. */
export type DictionaryJson = { [k: string]: string | DictionaryJson };

export type LangNamespaceLookup = {
  /** Request this language specifically. */
  lang?: string;
  /** Get phrases from this namespace. */
  namespace?: string;
}
